<template>
  <v-dialog
    :value="showDialog"
    width="650"
    @input="closeDialog"
  >
    <v-card>
      <v-toolbar
        dark
        dense
        color="blue darken-1 PostDetailDialog"
      >
        <v-toolbar-title>
          <span v-if="detail">{{ detail.title }}</span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="dialog-conente-scroll">
        <div
          v-if="detail"
          class="text-xs-right mb-2"
        >
          <time class="grey--text">{{ detail.publishedAt | dateFormat('YYYY-MM-DD HH:mm:ss') }}</time>
        </div>
        <HtmlViwer
          v-if="detail"
          :content="detail.content"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {
  },
  props: {
    showDialog: Boolean,
    poid: String,
  },
  data () {
    return {
      detail: null,
    }
  },
  watch: {
    poid () {
      this.detail = null
      if (this.poid) {
        this.fetchDetail()
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('update:showDialog', false)
    },
    async fetchDetail () {
      const res = await this.$store.dispatch('post/viewPage', {
        poidSlug: this.poid,
      })
      console.log(res.data.model)
      if (!res.data.error) {
        this.detail = res.data.model
      }
    },
  }
}
</script>
<style lang="postcss">
.PostDetailDialog {
  .v-toolbar__content {
    height: auto !important;
    .v-toolbar__title {
      white-space: inherit;
      padding: 5px 0;
    }
  }
}
</style>
